import { useIntl } from 'react-intl';
import { getClientConfig } from './getClientConfig';

/**
 * @typedef {"contactEmail" | "homeUrl" | "jobSearchUrl" | "disclaimerUrl" | "privacyPolicyUrl" | "dataProtectionUrl"} TranslationHelpers
 */

/**
 * @typedef {Record<LanguagesShort, RichTextValues>} RichTextValuesLocales
 */

/**
 * @typedef {Record<TranslationHelpers,string>} RichTextValues
 */

/**
 * @returns {{ richTextValues: RichTextValues }}
 */
export const useGetRichTextValues = () => {
  const { locale } = useIntl();
  const { translationHelpers } = getClientConfig();
  return { richTextValues: translationHelpers[locale] };
};
